// extracted by mini-css-extract-plugin
module.exports = {"disabled":"SemainesSchedulerDate_disabled__2jxxk","color":"SemainesSchedulerDate_color__3GhOq"};